import React from 'react';
import { EditableText, EditableImg } from '@smartfire/components';
import { useSmartProp, defineBlock, smartProps, useInspectorControl, useEditor } from '@smartfire/js-block-engine';
import { PanelBody, PanelRow, TextControl } from '@wordpress/components';
import Button from '../button/block';

import style from './block.module.scss';

function Inspector() {
    const [startText, setStartText] = useSmartProp('startText');
    const [startLink, setStartLink] = useSmartProp('startLink');
    const [learnMoreLink, setLearnMoreLink] = useSmartProp('learnMoreLink');

    return (
        <PanelBody title="Configuration" initialOpen={true}>
            <PanelRow>
                <TextControl label="Text bouton Commencer" value={startText} onChange={setStartText} />
            </PanelRow>
            <PanelRow>
                <TextControl label="Lien bouton Commencer" value={startLink} onChange={setStartLink} />
            </PanelRow>
            <PanelRow>
                <TextControl label="Lien En savoir plus" value={learnMoreLink} onChange={setLearnMoreLink} />
            </PanelRow>
        </PanelBody>
    );
}

function Block({ startText, startLink, learnMoreLink }) {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();

    const Wrapper = isEditing ? 'div' : 'a';

    return (
        <div className={style.block}>
            <EditableImg smartProp={'logo'} className={style.logo} />

            <div>
                <EditableText
                    smartProp={'title'}
                    className={style.title}
                    placeholder="Dyson Quizz"
                    allowedFormats={['core/bold', 'core/italic', 'core/text-color']}
                />
                <EditableText
                    smartProp={'subtitle'}
                    className={style.subtitle}
                    placeholder="Etes-vous un expert Dyson ? Répondez à nos 3 quizz et obtenez votre certificat !"
                    allowedFormats={['core/bold', 'core/italic', 'core/text-color']}
                />
            </div>

            <div>
                <Button label={startText} url={startLink} />

                <Wrapper href={learnMoreLink} target="_blank">
                    <EditableText
                        smartProp={'learnMore'}
                        className={style.learnMore}
                        placeholder="En savoir plus sur Dyson"
                        allowedFormats={['core/bold', 'core/italic', 'core/text-color']}
                    />
                </Wrapper>
            </div>
        </div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        logo: smartProps.picto,
        title: smartProps.string.withDefault(''),
        subtitle: smartProps.string.withDefault(''),
        startText: smartProps.string.withDefault(''),
        startLink: smartProps.string.withDefault(''),
        learnMore: smartProps.string.withDefault(''),
        learnMoreLink: smartProps.string.withDefault(''),
    },
    setup: {
        title: 'Home',
    },
});
